var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGb(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_57_30496)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.48081 4.69312C1.5382 5.91951 0.827433 7.33302 0.413574 8.8686H6.65629L2.48081 4.69312Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5874 8.8688C23.1735 7.33327 22.4627 5.91975 21.5201 4.69336L17.3447 8.8688H23.5874Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.413574 15.1304C0.827481 16.6659 1.53825 18.0794 2.48081 19.3058L6.65616 15.1304H0.413574Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3058 2.47988C18.0794 1.53727 16.666 0.826504 15.1304 0.412598V6.65527L19.3058 2.47988Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.69385 21.5179C5.92024 22.4605 7.33376 23.1712 8.86929 23.5852V17.3425L4.69385 21.5179Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.86924 0.412598C7.33371 0.826504 5.92019 1.53727 4.69385 2.47983L8.86924 6.65522V0.412598Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1304 23.5852C16.6659 23.1712 18.0794 22.4605 19.3058 21.5179L15.1304 17.3425V23.5852Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3447 15.1304L21.5201 19.3058C22.4627 18.0795 23.1735 16.6659 23.5874 15.1304H17.3447Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.8984 10.4348H13.5653H13.5653V0.101578C13.0529 0.034875 12.5305 0 12 0C11.4694 0 10.9471 0.034875 10.4348 0.101578V10.4347V10.4347H0.101578C0.034875 10.9471 0 11.4695 0 12C0 12.5306 0.034875 13.0529 0.101578 13.5652H10.4347H10.4347V23.8984C10.9471 23.9651 11.4694 24 12 24C12.5305 24 13.0529 23.9652 13.5652 23.8984V13.5653V13.5653H23.8984C23.9651 13.0529 24 12.5306 24 12C24 11.4695 23.9651 10.9471 23.8984 10.4348Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1304 15.1312L20.4852 20.486C20.7315 20.2398 20.9664 19.9824 21.1906 19.7156L16.6061 15.1311H15.1304V15.1312Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.86951 15.1311H8.86941L3.51465 20.4859C3.76084 20.7322 4.01823 20.9671 4.28504 21.1912L8.86951 16.6067V15.1311Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.86927 8.86911V8.86902L3.51446 3.51416C3.26818 3.76035 3.03324 4.01774 2.80908 4.28455L7.3936 8.86907H8.86927V8.86911Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1304 8.87029L20.4852 3.51539C20.239 3.26911 19.9817 3.03417 19.7148 2.81006L15.1304 7.39457V8.87029Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_57_30496"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGb);
export default __webpack_public_path__ + "static/media/GB.0865b1514f8a158c87706b88c0bac070.svg";
export { ForwardRef as ReactComponent };